import { wuxiaFilms } from "@/mocks/films";

export default function WuxiaZone() {
  return (
    <section id="wuxia" className="w-full bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <header className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-secondary-800 bg-secondary-100 px-3 py-1.5 rounded-full">
              <i className="ri-sword-line" aria-hidden="true"></i>
              武侠片
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug">
              刀光背后，讲的是选择与自由
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              武侠片常被记住的是打斗，但真正留下印象的往往是人物在江湖里的处境。以下三部作品用不同方式处理空间、情绪与道义。
            </p>
          </header>

          <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
            {wuxiaFilms.map((film) => (
              <article
                key={film.id}
                className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200"
              >
                <div className="relative w-full h-[210px] md:h-[230px] overflow-hidden">
                  <img
                    src={film.image}
                    alt={`${film.title} 风格场景插画`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-secondary-900 text-xs font-label">
                    {film.point}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-4 md:p-5">
                  <div className="flex items-center gap-2 text-xs font-label text-accent-700">
                    <span className="font-semibold">{film.year}</span>
                    <span className="w-px h-3 bg-background-300"></span>
                    <span>{film.tags.join(" · ")}</span>
                  </div>
                  <h3 className="mt-2 font-heading text-lg md:text-xl font-bold text-foreground-950">{film.title}</h3>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{film.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}